import { render } from "./DeliveryHistory.vue?vue&type=template&id=53f1a928"
import script from "./DeliveryHistory.vue?vue&type=script&lang=js"
export * from "./DeliveryHistory.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__